import React from 'react';
import { Column, Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';
import CollapsibleContent from '../collapsible/CollapsibleContent';
import { useSidebar } from '../../../hooks/useSidebar';
import { useLocation, } from "react-router-dom";


const useStyles = createUseStyles({
    activeContainer: {
        backgroundColor: ({ theme }) => theme.color.paleBlueTransparent
    },
    container: {
        display: 'flex',
        height: 56,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: ({ theme }) => theme.color.paleBlueTransparent
        },
        paddingLeft: ({ level }) => 32 * level,
        transition: 'all 0.2s ease-in-out',
    },
    leftBar: {
        borderLeft: ({ theme, level }) =>
            level > 1 ? 'none' : `3px solid #684FFB`,
        height: '2.8rem'
    },
    title: {
        fontSize: 16,
        lineHeight: '20px',
        letterSpacing: '0.2px',
        color: '#CCD0D8',
        marginLeft: 24
    },
    selectedTitle: {
        fontSize: 16,
        lineHeight: '20px',
        letterSpacing: '0.2px',
        color: 'white',
        marginLeft: 24,
        fontWeight: ' bold'
    },
});

function MenuItemComponent({ children, image: image, id, items = [], level = 1, onClick, title, currentNav }) {
    const pathname = useLocation();
    const theme = useTheme();
    const isCollapsible = children && children.length > 0;
    const { isExpanded, isActive, onItemClick } = useSidebar({
        isCollapsible,
        item: id,
        items
    });
    const classes = useStyles({ theme, level, isActive });
    const classNameColumn = currentNav ? classes.leftBar : '';
    const classNameContainer = [classes.container, isActive && classes.activeContainer].join(' ');
    const iconColor = isActive ? theme.color.paleBlue : theme.color.grayishBlue2;


    function onItemClicked(e) {
        if (onClick) {
            onClick(e);
        }
        onItemClick();
    }
    return (
        <Column key={id} className={classNameColumn}>
            <Row vertical='center' onClick={onItemClicked} className={classNameContainer}>
                <img className={currentNav ? classes.selectedIcon : ''} alt='' src={image} fill={iconColor} opacity={!isActive && '0.4'} />
                <span className={currentNav ? classes.selectedTitle : classes.title} >{title}</span>
            </Row>
            {isCollapsible && (
                <CollapsibleContent expanded={isExpanded}>
                    {children.map((child) => child.type({ ...child.props }))}
                </CollapsibleContent>
            )}
        </Column>
    );
}

export default MenuItemComponent;
